/* unplugin-vue-components disabled */import script from "./Role.vue?vue&type=script&setup=true&lang=js"
export * from "./Role.vue?vue&type=script&setup=true&lang=js"

import "./Role.vue?vue&type=style&index=0&id=c8d3fd5e&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8d3fd5e"]])

export default __exports__